<template>
    <div class="avatar-group">
        <user-avatar v-for="(user) in users.slice(0, visibleCounter)"
                     v-bind:style="{'margin-left': marginLeft}"
                     :size="size"
                     :user="user">
        </user-avatar>
        <div class="user-avatar --counter"
             v-if="users.length - visibleCounter > 0"
             :class="{'xs': size === 'xs', 'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large'}"
             v-bind:style="{'margin-left': marginLeft}">
            +{{ users.length - visibleCounter }}
        </div>
        <btn-circle v-if="!hidePlusIcon" icon="/assets/img/icons/plus-icon.svg" @click="$emit('addToMagnusCards')"></btn-circle>
    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import BtnCircle from "@/components/core/BtnCircle.vue";

export default {
    name: 'AvatarGroup',
    components: {BtnCircle, UserAvatar},
    props: ['users', 'size', 'hidePlusIcon'],
    computed: {
        marginLeft() {
            if (this.size === 'xs') {
                return '-8px'
            }
            return '-16px'
        }
    },
    data() {
        return {
            visibleCounter: 3 //number of avatars to be visible
        }
    }
};

</script>
